import React, { Component } from 'react';

import Player from "./containers/player";
import Metadata from "./containers/metadata";
import Modal from "./containers/comments/modal";

class App extends Component {
	render() {
		return <>
			<Player />
			<Metadata />
			<Modal />
		</>;
	}
}

export default App;
